import axios from 'axios'
import {Message} from 'element-ui'
import requestCode from '@/utils/requestResponse'
import utils from '@/utils/'
import storage from '@/utils/storage'
import store from '@core/store/'

const config = require('../../../config')
const httpSetting = config[process.env.NODE_ENV === 'production' ? 'build' : 'dev'].httpSetting

const http = axios.create(httpSetting)
// 添加请求拦截器
// console.log(process.env.NODE_ENV, 'httpSetting')
http.interceptors.request.use(req => {
  // console.log(req, '所传req')
  // 拦截，给所有的请求添加loginsession
  if (req.method === 'get') {
    req.params = req.params || {}
    // req.data.parkId = 1
    req.params.parkId = req.params.parkId === 'null' ? null : (req.params.parkId || store.getters.parkId)
    req.params.areaId = req.params.parkId === 'null' ? null : (req.params.parkId || store.getters.parkId)
  } else {
    req.data = req.data || {}
    req.data.parkId = req.data.parkId === 'null' ? null : (req.data.parkId || store.getters.parkId)
    req.data.areaId = req.data.parkId === 'null' ? null : (req.data.parkId || store.getters.parkId)
  }

  // let clientToken = sessionStorage.getItem('clientToken')
  let Token = sessionStorage.getItem('Token')
  req.headers = Object.assign(req.headers.common || {}, {
    'loginToken': storage.get('loginToken'),
    'x-client-token': Token,
    'Authorization': Token
  })
  // if (process.env.NODE_ENV === 'development') {
  //   if (req.data ? req.data.test : req.params.test) {
  //     req.baseURL = ''
  //     req.url = 'http://10.161.61.189:7008' + req.url
  //     return req
  //   }
  //   if (req.data ? req.data.mockApi : req.params.mockApi) {
  //     req.baseURL = ''
  //     req.url = '/mock' + req.url
  //   } else {
  //     if (req.data ? !req.data.noIpark : !req.params.noIpark) {
  //       req.url = '/ipark' + req.url
  //     }
  //   }
  // } else {
  //   if (req.data ? !req.data.noIpark : !req.params.noIpark) {
  //     req.url = '/ipark' + req.url
  //   }
  // }
  // 联调时候需要去除usstate数据
  let url = req.url
  // if (process.env.NODE_ENV === 'production') {
  //   if (req.method === 'get' && req.params.usestatue === true) {
  //     req.url = '/api' + url
  //   } else {
  //     req.url = '/ipark' + url
  //   }
  // } else {
  //   if ((req.method === 'get' && req.params.usestatue === true) || (req.method === 'post' && req.data.usestatue === true)) {
  //     req.url = '/api' + url
  //   } else {
  //     req.url = '/ipark' + url
  //   }
  // }
  // if (req.method === 'get' && req.params.usestatue === true) {
  //   delete req.params.usestatue
  //   // console.log(req, '删除后的req')
  // }
  // if (req.method === 'post' && req.data.usestatue === true) {
  //   delete req.data.usestatue
  //   // console.log(req, '删除后的req')
  // }

  // console.log(req, '查询参数')
  // 运营管理-物流管理中的设备巡检、设备维保、维保单位管理3个板块的接口承接来自资产管理中的接口，相比ipark（运营管理）开头，资产管理是 API开头，故需要做接口兼容处理

  let getdata = req.params === undefined ? false : req.params
  let postdata = req.data === undefined ? false : req.data
  let getststus = !getdata ? false : (getdata.usestatue || false)
  let poststatus = !postdata ? false : (postdata.usestatue || false)
  // console.log(getststus, poststatus, 'getststus, poststatus')
  if (process.env.NODE_ENV === 'development') {
    if (req.data ? req.data.mockApi : req.params.mockApi) {
      req.baseURL = ''
      req.url = '/mock' + req.url
    } else if ((getststus && req.params.usestatue === true) || (poststatus && req.data.usestatue === true)) {
      req.url = '/api' + url // 可能要传api
      // req.url = url
    } else if (req.test === true) {
      req.url = '/test' + url
      // req.headers['Authorization'] = 'Bearer p0idJ7uDs6hXuBz49vPgkb8g2C9sVHW/Xc8kGU+eRZGOPYBrAq1qk7URKd1OBhVq'
      req.headers['cookie'] = 'Hm_lvt_6f9bf380bb2e973'
    } else if (req.data ? req.data.consumption : req.params.consumption) {
      req.url = '/consumption' + url
      // req.headers['Authorization'] = 'Bearer p0idJ7uDs6hXuBz49vPgkb8g2C9sVHW/Xc8kGU+eRZGOPYBrAq1qk7URKd1OBhVq'
      req.headers['cookie'] = 'Hm_lvt_6f9bf380bb2e973'
    } else if (req.data ? req.data.portal : req.params.portal) {
      req.url = '/portal' + req.url
    } else if (postdata && postdata.platformFlag) {
      req.url = '/gateway' + url // 可能要传api
      // document.cookie = 'access_token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmdhbiI6eyJERVBBUlRNRU5UX05BTUUiOiLlubPlj7Dov5Dnu7Tlhazlj7giLCJQT1NJVElPTl9JRCI6IlA3YjQ4YjVkZDZmNzI0MzdkYmZmZGVmYjc5ODU4NzM5NSIsIkVNUExPWUVFX0lEIjoiUEU2MTRiNzQ4YTIyYTE0ODlmYTRhZWU4ZWZjYjgwNTM1NSIsIkNPUlBPUkFUSU9OX0lEIjoiMSIsIkRFUEFSVE1FTlRfSUQiOiIxOTcxNWQzYTY4OTg0MDJjYjdkZmU3MjYxYWU0NjhiNyIsIlVTRVJfSUQiOiIxODMxMDM5NDUzNiIsIkNPUlBPUkFUSU9OX05BTUUiOiLljJfkuqzpgJrmmI7muZbkv6Hmga_ln47lj5HlsZXmnInpmZDlhazlj7giLCJFTVBMT1lFRV9OQU1FIjoi5YiY5b-X5LyfIiwiUE9TSVRJT05fTkFNRSI6IuWFtuS7liIsIklTX0RFRkFVTFQiOiIxIn0sInVzZXJNYXBMaXN0IjpbXSwidXNlcl9uYW1lIjoiMTgzMTAzOTQ1MzYiLCJzY29wZSI6WyJwbGF0Zm9ybSJdLCJleHAiOjE3MzY2MjA3MTgsInVzZXIiOnsidXNlclR5cGVDb2RlIjoiMDAiLCJzZWN1cml0eUNsYXNzaWZpY2F0aW9uIjoiMDAiLCJwd2RVcHRUaW1lIjoiMjAyMS0wOC0xMiAxNDo1OToyOSIsInB3ZFRpbWUiOm51bGwsInN5c1VzZXIiOiIwIiwidXNlck5hbWUiOiLliJjlv5fkvJ8iLCJ1c2VySWQiOiIxODMxMDM5NDUzNiIsImlkTnVtIjoiMTEwMDAifSwiY2xpZW50X2lkIjoicGxhdGZvcm0ifQ.Pr_H2FjynlWnb7K3CNPjVsc7XqKnixMc_JuU-oT9XaYnvW82l4V8gzjXrIxPAecOF0WVbkxbOt_YzOEWXcfM4XlX3SsKTCBZFQXMEvDS_-5PgXTf3nGEemRm_w5vbeiesbkE3QGpN_hjFdZqybrVKQ5oEbhIahGhkljDB5N5DFwcdAlxJXmZNQaEtNDuQD3yD8s7fs2GV4NR1nuBXNXHBl-0aNJ8Wvj3xHXI_f44o0a4z3cQAOVhxy6bJMPi4E39SZk-08KSfmdFKYtOl-C7BO-UQxBWj0307LepowaGDehbGjU0icn_GNSu2xPf_Cpd-jpGNDOncwxyKOmNlimVMw; refresh_token=; scope=platform; token_type=bearer;';
      // document.cookie = 'access_token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmdhbiI6eyJERVBBUlRNRU5UX05BTUUiOiLlubPlj7Dov5Dnu7Tlhazlj7giLCJQT1NJVElPTl9JRCI6IlA3YjQ4YjVkZDZmNzI0MzdkYmZmZGVmYjc5ODU4NzM5NSIsIkVNUExPWUVFX0lEIjoiUEViZWNmY2Q5ZWEwNDQ0ZjlmYTkxOTk1ZmU4MTZhMmY2NCIsIkNPUlBPUkFUSU9OX0lEIjoiMSIsIkRFUEFSVE1FTlRfSUQiOiIxOTcxNWQzYTY4OTg0MDJjYjdkZmU3MjYxYWU0NjhiNyIsIlVTRVJfSUQiOiIxNTg0OTI1NzU5MyIsIkNPUlBPUkFUSU9OX05BTUUiOiLljJfkuqzpgJrmmI7muZbkv6Hmga_ln47lj5HlsZXmnInpmZDlhazlj7giLCJFTVBMT1lFRV9OQU1FIjoi6YOt6ZuF6Iy5IiwiUE9TSVRJT05fTkFNRSI6IuWFtuS7liIsIklTX0RFRkFVTFQiOiIxIn0sInVzZXJNYXBMaXN0IjpbXSwidXNlcl9uYW1lIjoiMTU4NDkyNTc1OTMiLCJzY29wZSI6WyJwbGF0Zm9ybSJdLCJleHAiOjE3Mzk2NTIyMTksInVzZXIiOnsidXNlclR5cGVDb2RlIjoiMDAiLCJzZWN1cml0eUNsYXNzaWZpY2F0aW9uIjoiMDAiLCJwd2RVcHRUaW1lIjoiMjAyMS0wOS0yNiAxMjowNjoyMSIsInB3ZFRpbWUiOm51bGwsInN5c1VzZXIiOiIwIiwidXNlck5hbWUiOiLpg63pm4XojLkiLCJ1c2VySWQiOiIxNTg0OTI1NzU5MyIsImlkTnVtIjoiMTAwMDEifSwiY2xpZW50X2lkIjoicGxhdGZvcm0ifQ.oCzG6DnoPu7fRYDlyiJKaNzqcQzgduuNSiLE2zrIeqr-DgV8pjHyhh78-8rGSTqA8IYETPB9B8M-u6hb9w4rtPsZyrrrXmyM-Vufbf3wMXwpmWhDWolq_HRZYc5Gq-IP0H8CBcEHg1F85V6kSiPtNK3LL7d51sXgWzKSHIUUbLq6zS0JXkjiXnj0lRmbOa4GkZ7-VHZzDypgBn9qiDa-kx4ZkffXzwcu9eiO4970-owR0JWaRUouxqLrJnxzPGLqc24XRLFLwEZbxo2W0f988fQMQqVoEc5ggM5zG44pr5Opml6VB2tG-jXZTMay68-czCzEYi4xl0A-G03TTKg6QA; token_type=bearer'
    } else {
      req.url = '/ipark' + url
      req.headers['cookie----'] = 'Hm_lvt_6f9bf380bb2e973'
    }
  } else if (postdata && postdata.platformFlag) {
    // 执行自建服务请求——工作流相关
    req.url = '/gateway' + url
  } else {
    if ((getststus && req.params.usestatue === true) || (poststatus && req.data.usestatue === true)) {
      req.url = '/api' + url // 可能要传api
      // req.url = url
    } else {
      req.url = '/ipark' + url
    }
  }
  // req.headers['cookie'] = 'passport-sso=e290669c915a9df1ecd0b169c3a70023; Hm_lvt_63a5de9377e9fb4fc7a7b48ba436a667=1742369970; HMACCOUNT=0A565BA79C2A5D5C; passport-sso=e290669c915a9df1ecd0b169c3a70023; Hm_lpvt_63a5de9377e9fb4fc7a7b48ba436a667=1742439232; access_token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmdhbiI6eyJERVBBUlRNRU5UX05BTUUiOiLlubPlj7Dov5Dnu7Tlhazlj7giLCJQT1NJVElPTl9JRCI6IlA3YjQ4YjVkZDZmNzI0MzdkYmZmZGVmYjc5ODU4NzM5NSIsIkVNUExPWUVFX0lEIjoiUEViZWNmY2Q5ZWEwNDQ0ZjlmYTkxOTk1ZmU4MTZhMmY2NCIsIkNPUlBPUkFUSU9OX0lEIjoiMSIsIkRFUEFSVE1FTlRfSUQiOiIxOTcxNWQzYTY4OTg0MDJjYjdkZmU3MjYxYWU0NjhiNyIsIlVTRVJfSUQiOiIxNTg0OTI1NzU5MyIsIkNPUlBPUkFUSU9OX05BTUUiOiLljJfkuqzpgJrmmI7muZbkv6Hmga_ln47lj5HlsZXmnInpmZDlhazlj7giLCJFTVBMT1lFRV9OQU1FIjoi6YOt6ZuF6Iy5IiwiUE9TSVRJT05fTkFNRSI6IuWFtuS7liIsIklTX0RFRkFVTFQiOiIxIn0sInVzZXJNYXBMaXN0IjpbXSwidXNlcl9uYW1lIjoiMTU4NDkyNTc1OTMiLCJzY29wZSI6WyJwbGF0Zm9ybSJdLCJleHAiOjE3NDI3NDE2NDEsInVzZXIiOnsidXNlclR5cGVDb2RlIjoiMDAiLCJzZWN1cml0eUNsYXNzaWZpY2F0aW9uIjoiMDAiLCJwd2RVcHRUaW1lIjoiMjAyMS0wOS0yNiAxMjowNjoyMSIsInB3ZFRpbWUiOm51bGwsInN5c1VzZXIiOiIwIiwidXNlck5hbWUiOiLpg63pm4XojLkiLCJ1c2VySWQiOiIxNTg0OTI1NzU5MyIsImlkTnVtIjoiMTAwMDEifSwiY2xpZW50X2lkIjoicGxhdGZvcm0ifQ.PKd5BiTogZghtGCuO0UCWkFLSaHkSvt8540W9KgijgzhTi4_yhIzk27JG8BXGEvFaGbDTWlqnDZFBEgOs9fPDisfO9CMmPF0DikcfbuhJETaJR3yKhk4-Wu4Wg1NpHLiD1v2SkpVQjyj4jUwieLv4O3kfVxpgerRFUjR-7ksUYf1mUrMbNysa1fZHNPydZ6qfc3G6y5YGnKzI4jal0tXB1bShPhLuY9MnDHr7tHqzyA9O_FO1Kj4XWu1RzlYwMHvXEIpIkpjek6SK0MRJeWWRhd3HBpmRuI9tGKENDc5Sgf-tisRZNxBw5afisAr3t2zPYFSVs6aow7trs0MoPwJBg; token_type=bearer'
  if ((getststus && req.params.useToken === true) || (poststatus && req.data.useToken === true)) {
    let clientToken = sessionStorage.getItem('clientToken')
    let Token = sessionStorage.getItem('Token')
    req.headers['x-client-token'] = clientToken
    console.log('走进clientToken', clientToken)
    req.headers['Authorization'] = Token
  }
  if (getststus) {
    delete req.params.usestatue
    delete req.params.areaId
    // console.log(req, '删除后的req')
  }
  if (poststatus) {
    delete req.data.usestatue
    delete req.data.areaId
    // console.log(req, '删除后的req')
  }
  if (poststatus && req.data.useToken === true) {
    delete req.data.useToken
    // console.log(req, '删除后的req')
  }
  if (getststus && req.params.useToken === true) {
    delete req.params.useToken
    // console.log(req, '删除后的req')
  }
  return req
}, error => {
  return Promise.reject(error)
})

http.interceptors.response.use(resp => { // 响应前置处理
  if (resp.config.url === '/ipark/portal/user/getCurrentLoginUmUserInfo' && resp.data === null) {
    window.location.href = '/ipark/passport/login'
  } else {
    // 请求正常返回
    const resultData = resp.data
    if (resultData) {
      if (resultData.code) {
        if (resultData.encryptFlag) {
          resultData.body = utils.aesDecrypt(resultData.body)
        }
        // console.log(resultData.code, 'resultData.code')
        if (resultData.code === requestCode.ZIGUANREQUESTSUCESS.code || resultData.code === requestCode.REQUESTSUCESS.code || resultData.code === requestCode.LOGINSUCCESS.code) {
          return Promise.resolve(resultData)
          // } else if (resultData.code === requestCode.REQUESTFAIL.code || resultData.code === requestCode.LOGINFAIL.code) {
          // eslint-disable-next-line eqeqeq
        } else if (resultData.code == 606) {
          // 请求登录态验证，如果没有登录态就退出，重新登录
          Message({
            type: 'error',
            message: '登录已过期，请重新登录',
            duration: 2000,
            onClose () {
              storage.set('logout', true)
              utils.logout()
            }
          })
        } else if (resultData.code === '500') {
          return Promise.resolve({
            code: resultData.code,
            errorMessage: resultData.msg
          })
        } else if (Object.keys(requestCode.errorCode).find(code => code === resultData.code)) {
          // 请求特殊错误码处理，如果满足某错误码，就给出对应提示。错误码提示在/utils/requestResponse里进行配置
          // Message({
          //   type: 'error',
          //   message: requestCode.errorCode[resultData.code],
          //   duration: 2000
          // })
          console.log('进入了别的服务')
          return Promise.resolve({
            code: resultData.code,
            errorMessage: requestCode.errorCode[resultData.code]
          })
        } else if (resultData.code === '601' || resultData.code === '602') {
          return Promise.resolve({
            code: resultData.code,
            errorMessage: resultData.body || resultData.message
          })
        } else {
          return Promise.resolve({
            code: resultData.code,
            errorMessage: resultData.body || resultData.message,
            data: resultData.data
          })
        }
      } else if (resultData.type) { // 下载或者其他非常规请求
        return Promise.resolve(resultData)
      } else {
        // Message({
        //   type: 'error',
        //   message: `网络请求失败，错误代码: 10002`,
        //   duration: 2000
        // })
        // 兼容处理，兼容自建服务返回值
        if (resp.config.url.indexOf('/gateway') >= 0) {
          return Promise.resolve(resultData)
        } else {
          return Promise.reject(new Error(`网络请求失败，错误代码: 10002`))
        }
      }
    } else {
      console.log('......1...........')
      // utils.logout()
    }
  }
}, error => {
  // 请求异常返回
  const resp = error.response
  if (resp === null || resp === undefined) {
    // 网络异常或者服务器无响应
    Message({
      type: 'error',
      // message: '服务器异常，请稍后再试',
      duration: 3000
    })
    // utils.logout()
  } else {
    switch (resp.status) {
      case 502:
        Message({
          type: 'error',
          message: '系统维护中，请稍后再试，错误代码:502',
          duration: 3000
        })
        // utils.logout()
        break
      default:
    }
  }
  return Promise.reject(error)
})

export default http



// WEBPACK FOOTER //
// ./src/area-base/api/base.js